import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    checkboxGroup: {
        marginTop: theme.spacing(1),
    },
    formLabel: {
        marginBottom: theme.spacing(2),
    },
    typeDesc: {
        padding: theme.spacing(2),
    },
}));
